import { Forecast, ForecastIndex } from '@/models'
import { APIEndpoints, APIScopes, APIURL, BaseService, type IAuthService } from '@/services'

// import { forecasts } from '../../../data/sampleForecast'
export class ForecastService extends BaseService {
	constructor(authService: IAuthService) {
		super(APIURL, authService, APIScopes)
	}
	async getIndex(): Promise<ForecastIndex[]> {
		// return forecasts.map((c) => new ForecastIndex(c))
		return this.getData<ForecastIndex[]>(`${APIEndpoints.forecast}/`)
			.then((data) => {
				console.log(data)
				return data.map((c: ForecastIndex) => new ForecastIndex(c))
			})
			.catch((err) => {
				throw err
			})
	}
	async get(id: number): Promise<Forecast> {
		return this.getData<Forecast>(`${APIEndpoints.forecast}/${id}`)
			.then((data) => {
				return new Forecast(data)
			})
			.catch((err) => {
				throw err
			})
	}

	async update(forecast: Forecast): Promise<Forecast> {
		const obj = forecast
		return this.patchData(`${APIEndpoints.forecast}/update/${forecast.id}`, obj)
			.then((data) => {
				return new Forecast(data)
			})
			.catch((err) => {
				throw err
			})
	}
}
